/* eslint-disable no-nested-ternary */
import { Box } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { ChatMessageContact as MessageContact } from '@src/types';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export type ChatMessageContactQuotedProps = {
  contacts: MessageContact[] | undefined;
};

const ChatMessageContactQuoted: React.FC<ChatMessageContactQuotedProps> = ({
  contacts,
}) => {
  const { formatMessage } = useIntl();
  const primaryContact = useMemo(() => contacts?.at(0), [contacts]);
  const qtyContacts = useMemo(() => contacts?.length || 0, [contacts]);
  const hasMoreOnceContact = useMemo(() => qtyContacts > 1, [qtyContacts]);
  const contactFullName = useMemo(
    () =>
      `${primaryContact?.name.first_name} ${
        primaryContact?.name?.last_name || ''
      }`,
    [primaryContact]
  );

  return (
    <Box
      style={{
        height: 30,
        display: 'flex',
        alignItems: 'center',
        gridGap: 8,
        color: '#5F6368',
      }}
    >
      <AccountCircleIcon style={{ width: 22, height: 22 }} />
      <span style={{ fontWeight: 500 }}>
        {contacts && hasMoreOnceContact
          ? formatMessage(
              { id: 'Console.ContactMessage.OthersContacts' },
              { name: contactFullName, qty: qtyContacts - 1 }
            )
          : contactFullName}
      </span>
    </Box>
  );
};

export default ChatMessageContactQuoted;
